import React from 'react'
import styled from 'styled-components'
import {FaPhone} from 'react-icons/fa'

import {colors} from '~/constants/style'

const Layout = styled.div``

Layout.HeaderWrapper = styled.header``

Layout.FooterWrapper = styled.footer``

Layout.Main = styled.main``

const phoneBtnHeight = '45px'

Layout.PhoneButton = styled.a.attrs({
  children: <FaPhone />,
})`
  z-index: 1;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: ${phoneBtnHeight};
  height: ${phoneBtnHeight};
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  color: white !important;
  background-color: ${colors.red};
`

export default Layout
